export default __webpack_public_path__ + "static/media/background.ff07a0a2.svg";